import { useSearchParams, Link } from 'react-router-dom'
import { CheckCircle, Sparkles, ArrowRight, Mail } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function ThankYou() {
  const [searchParams] = useSearchParams()
  const email = searchParams.get('email')

  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-6">
      <div className="max-w-2xl mx-auto text-center">
        <div className="mb-8">
          <div className="w-24 h-24 rounded-full bg-[#D4AF37]/20 flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-12 h-12 text-[#D4AF37]" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-[#D4AF37] to-[#FFD700] bg-clip-text text-transparent">
            Thank You!
          </h1>
          <p className="text-xl text-gray-400 mb-2">Thanks for your interest in Binyuma TV</p>
          {email && (
            <div className="flex items-center justify-center gap-2 text-gray-500">
              <Mail className="w-4 h-4" />
              <span className="text-sm">{email}</span>
            </div>
          )}
        </div>
        <div className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-2xl p-8 mb-8">
          <div className="space-y-6 text-left">
            <div className="flex items-start gap-4">
              <Sparkles className="w-6 h-6 text-[#D4AF37] flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-bold text-lg mb-2">What's Next?</h3>
                <p className="text-gray-400">
                  Create an account to start watching African vertical drama and join the Binyuma TV community.
                </p>
              </div>
            </div>
            <ul className="space-y-4 ml-10">
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] font-bold">1.</span>
                <span className="text-gray-300">
                  Sign up for a free account
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] font-bold">2.</span>
                <span className="text-gray-300">
                  Download the app or use the web player
                </span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-[#D4AF37] font-bold">3.</span>
                <span className="text-gray-300">
                  Start watching exclusive African stories in vertical format
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/signup">
            <Button className="bg-[#D72638] hover:bg-[#D72638]/90 text-white">
              Create account
              <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </Link>
          <Link to="/login">
            <Button variant="secondary" className="border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37]/10">
              Sign in
            </Button>
          </Link>
          <Link to="/">
            <Button variant="secondary" className="border-gray-600 text-gray-300 hover:bg-gray-800">
              Return to Home
            </Button>
          </Link>
        </div>
        <div className="mt-12 pt-8 border-t border-gray-900">
          <p className="text-gray-500 text-sm mb-4">Connect with us</p>
          <div className="flex justify-center gap-6">
            <a href="#" className="text-gray-400 hover:text-[#D4AF37] transition-colors" aria-label="Twitter">Twitter</a>
            <a href="#" className="text-gray-400 hover:text-[#D4AF37] transition-colors" aria-label="Instagram">Instagram</a>
            <a href="#" className="text-gray-400 hover:text-[#D4AF37] transition-colors" aria-label="Facebook">Facebook</a>
          </div>
        </div>
      </div>
    </div>
  )
}
